import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useDownloadAppPage from './hooks/useDownloadAppPage';
import DownloadAppView from './view';

/**
 * Public smart link for the app (route: /download). It's the URL the QR code in
 * the download modal encodes: a phone that scans it is sent straight to its own
 * store, a computer gets the same QR modal over a bare canvas. Rendered by
 * App.js's public branch — outside the app shell and without the auth redirect.
 */
export default function DownloadApp() {
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const page = useDownloadAppPage();

    useEffect(() => {
        document.title = t('downloadApp.documentTitle');
    }, [t]);

    return <DownloadAppView {...page} onClose={() => navigate('/')} />;
}
